import React, { useMemo } from 'react';
import { Layout } from 'lucide-react';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import PreviewRenderer from './PreviewRenderer';

const TemplatePreviewModal = ({ template, onClose, onUse }) => {
  // Generate a new key each time modal opens to force theme refresh
  const refreshKey = useMemo(() => Date.now(), [template?.template_id]);
  
  if (!template) return null;

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="max-w-6xl max-h-[90vh] overflow-hidden flex flex-col">
        <DialogHeader className="flex-shrink-0">
          <div className="flex items-center justify-between">
            <div>
              <DialogTitle className="text-xl">{template.name}</DialogTitle>
              {template.description && (
                <p className="text-sm text-slate-500 mt-1">{template.description}</p>
              )}
            </div>
            <div className="flex items-center gap-2">
              <Button onClick={onUse} className="gap-2">
                <Layout size={16} />
                Use This Template
              </Button>
            </div>
          </div>
        </DialogHeader>
        
        <div className="flex-1 overflow-auto bg-slate-100 rounded-lg mt-4">
          {/* Render the template using the same code path as the live page
              (isQuickPreview=false). Quick Preview would force full-width
              blocks to 100vw which then get clipped inside the modal and
              cause columns / videos to appear as empty grey boxes. */}
          <div className="bg-white rounded-lg shadow-sm overflow-x-hidden">
            <PreviewRenderer
              blocks={template.blocks || []}
              title={template.name}
              pageWidth={template.page_width || 'standard'}
              theme={template.theme}
              isQuickPreview={false}
              showNavigation={false}
              refreshKey={refreshKey}
            />
          </div>
        </div>

        <div className="flex-shrink-0 flex justify-between items-center pt-4 border-t mt-4">
          <div className="text-sm text-slate-500">
            <span className="px-2 py-1 bg-slate-100 rounded mr-2 capitalize">{template.category}</span>
            <span className="px-2 py-1 bg-slate-100 rounded">{template.page_width || 'standard'} width</span>
          </div>
          <div className="flex gap-2">
            <Button variant="outline" onClick={onClose}>
              Close
            </Button>
            <Button onClick={onUse}>
              Use Template
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TemplatePreviewModal;
